import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import BlogSeries from '../../../components/BlogSeries';

const posts = [
  {
    num: 'observability',
    title: 'Observability',
    date: 'Mar 3, 2025',
    summary:
      'How to implement centralized logging, SIEM, and alerting for cloud infrastructure. Covers managed and custom setups, dashboards, and actionable monitoring for security and operations.',
    hashtags: ['#Observability', '#SIEM', '#CloudSecurity', '#Monitoring', '#AWS'],
  },
  {
    num: 'antivirus-scanning-and-security-patching',
    title: 'Antivirus Scanning and Security Patching',
    date: 'Feb 7, 2025',
    summary:
      'Best practices for integrating antivirus scanning and automated security patching into your cloud infrastructure. Includes AMI/container pipeline tips and cloud-native patching tools.',
    hashtags: ['#Antivirus', '#Patching', '#CloudSecurity', '#DevSecOps', '#Automation'],
  },
  {
    num: 'vulnerability-management-system-runtime',
    title: 'Vulnerability Management System – Part 3: Scanning at Runtime',
    date: 'Jan 10, 2025',
    summary:
      'How to set up runtime vulnerability scanning with XDR tools like Wazuh and Nessus Pro. Covers continuous monitoring, alerting, and prioritizing CVEs in production.',
    hashtags: ['#VulnerabilityManagement', '#XDR', '#RuntimeSecurity', '#CVE', '#CloudOps'],
  },
  {
    num: 'vulnerability-management-system-containers',
    title: 'Vulnerability Management System – Part 2: Containers',
    date: 'Dec 12, 2024',
    summary:
      'Hardening and scanning container images for vulnerabilities. Learn about CIS Docker Benchmarks, DoD Iron Bank, and automated verification in your CI/CD pipeline.',
    hashtags: ['#Containers', '#VulnerabilityManagement', '#Docker', '#DevSecOps', '#CICD'],
  },
  {
    num: 'vulnerability-management-system',
    title: 'Vulnerability Management System – Part 1: Hosts',
    date: 'Nov 15, 2024',
    summary:
      'How to build and maintain secure golden images for cloud hosts. Includes OS hardening, CIS/DISA benchmarks, and automated vulnerability scanning.',
    hashtags: [
      '#VulnerabilityManagement',
      '#GoldenImage',
      '#CISBenchmarks',
      '#CloudSecurity',
      '#Hardening',
    ],
  },
  {
    num: 'data-backup-and-recovery',
    title: 'Data Backup and Recovery',
    date: 'Oct 18, 2024',
    summary:
      'Establishing data classification, retention, backup, and recovery policies for cloud environments. Practical steps for lifecycle management and compliance.',
    hashtags: ['#Backup', '#Recovery', '#DataRetention', '#CloudCompliance', '#CloudOps'],
  },
  {
    num: 'data-encryption',
    title: 'Data Encryption',
    date: 'Sep 20, 2024',
    summary:
      'Comprehensive guide to encrypting data at rest and in transit in the cloud. Covers key management, IAM policies, and encryption best practices.',
    hashtags: ['#Encryption', '#CloudSecurity', '#KeyManagement', '#DataProtection', '#AWS'],
  },
  {
    num: 'deny-by-default',
    title: 'Deny by Default, Allow by Exception',
    date: 'Aug 22, 2024',
    summary:
      'How to implement a deny-all, allow-by-exception security posture in the cloud. Includes region/service restrictions, firewalls, and encryption key management.',
    hashtags: ['#CloudSecurity', '#LeastPrivilege', '#DenyByDefault', '#Governance', '#AWS'],
  },
  {
    num: 'access-control',
    title: 'Access Control',
    date: 'Jul 25, 2024',
    summary:
      'Step-by-step approach to centralized access control in cloud environments. Covers SSO, RBAC, least privilege, and secure access request workflows.',
    hashtags: ['#AccessControl', '#IAM', '#RBAC', '#CloudSecurity', '#Compliance'],
  },
  {
    num: 'what-is-a-cloud-security-posture',
    title: 'What is a Cloud Security Posture?',
    date: 'May 27, 2024',
    summary:
      'A comprehensive overview of cloud security posture elements: access, encryption, backup, observability, and more. Great starting point for cloud security strategy.',
    hashtags: ['#CloudSecurity', '#SecurityPosture', '#BestPractices', '#Compliance', '#CloudOps'],
  },
];

const CloudSecuritySeries = () => (
  <div className="cloud-security-series-page blog-page">
    <Breadcrumb
      items={[
        { path: '/', label: 'Home' },
        { path: '/blog', label: 'Blog' },
        { path: '/blog/cloud-security-series', label: 'Cloud Security Series' },
      ]}
    />
    <BlogSeries
      posts={posts}
      seriesTitle="Cloud Security Series"
      seriesPath="/blog/cloud-security-series"
    />
  </div>
);

export default CloudSecuritySeries;
